export default __webpack_public_path__ + "alberta-reorder.1844bffb60d6818ec013.svg";